export default __webpack_public_path__ + "static/media/searchempty.4db0ea6c.svg";